export const TRANSLATE = "translate";
export const MANAGE_USERS = "manage_users";
export const USE_ADVISORY = "use_advisory";
export const USE_OCR = "use_ocr";
export const USE_CONFIGURATIONS = "use_configurations";
